import { render, staticRenderFns } from "./detail-products.vue?vue&type=template&id=6d2abf1e&"
import script from "./detail-products.vue?vue&type=script&lang=js&"
export * from "./detail-products.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox, CModalCloseButton: require('@chakra-ui/vue').CModalCloseButton, CImage: require('@chakra-ui/vue').CImage, CHeading: require('@chakra-ui/vue').CHeading, CText: require('@chakra-ui/vue').CText, CListItem: require('@chakra-ui/vue').CListItem, CList: require('@chakra-ui/vue').CList, CFlex: require('@chakra-ui/vue').CFlex, CButton: require('@chakra-ui/vue').CButton, CModalBody: require('@chakra-ui/vue').CModalBody, CModalContent: require('@chakra-ui/vue').CModalContent, CModalOverlay: require('@chakra-ui/vue').CModalOverlay, CModal: require('@chakra-ui/vue').CModal})
